import { css } from '@emotion/react'
import { useTranslation } from 'next-i18next'
import { useState } from 'react'
import { styled } from 'styles/styled'
import { themeUtils } from 'styles/theme'
import CarouselGallery from './CarouselGallery'
import CarouselPhone from './CarouselPhone'
import CustomModal from './CustomModal'
import {
  ButtonCaroussel,
  ImageContainer,
  ImageViewContainer,
  StyledImage
} from './map/ImagesView.style'
import 'swiper/css'
import 'swiper/css/pagination'

interface ImageViewProps {
  images: Array<string>
  eventId: number
  eventName: string
}
const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  @media only screen and (min-width: 1500px) {
    align-items: center;
  }

  ${themeUtils.maxWidth.md} {
    height: auto;
    padding: 0 16px;
  }
`

const FirstContainer = styled.div`
  margin: auto;
  ${themeUtils.maxWidth.md} {
    display: none;
  }
`

const SecondContainer = styled.div`
  display: none;
  ${themeUtils.maxWidth.md} {
    display: block;
  }
`
export default function ImagesView({
  images,
  eventId,
  eventName
}: ImageViewProps) {
  const [showSwiper, setShowSwiper] = useState(false)
  const [currentSlide, setCurrentSlide] = useState(0)
  const displayImages = images.slice(0, 5)
  const { t } = useTranslation('event')

  const handleOpen = (index: number) => {
    setCurrentSlide(index)
    setShowSwiper(true)
  }
  const handleClose = () => {
    setShowSwiper(false)
  }

  return (
    <>
      <FirstContainer>
        <MainContainer>
          <ImageViewContainer>
            {displayImages.map((src, index) => (
              <ImageContainer key={index} onClick={() => handleOpen(index)}>
                <StyledImage
                  alt={`${eventName} - image`}
                  src={src.trim()}
                  priority={index === 0}
                  fill
                  sizes="(max-width: 768px) 100vw, 768px"
                  $index={index}
                  css={css`
                    object-fit: cover;
                  `}
                />
              </ImageContainer>
            ))}
            <ButtonCaroussel
              onClick={() => handleOpen(0)}
              label={t('seeAllPhotos')}
            />
          </ImageViewContainer>
        </MainContainer>
      </FirstContainer>
      <SecondContainer>
        <CarouselPhone images={images} />
      </SecondContainer>
      <CustomModal isOpen={showSwiper} handleClose={handleClose}>
        <CarouselGallery
          eventId={eventId}
          handleClose={handleClose}
          images={images}
          currentSlide={currentSlide}
          setCurrentSlide={setCurrentSlide}
          eventName={eventName}
        />
      </CustomModal>
    </>
  )
}
